import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Translate } from "../../../Enums/Tranlate";
import Select from "react-select";
import VendorsService from "../../../../services/VendorsService";
import ReviewsService from "../../../../services/ReviewsService";
import LoaderImg from "../../../common/LoaderImg";
import BaseService from "../../../../services/BaseService";

const AddReviewsModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const location = useLocation();
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		no_of_stars: "",
		image: "",
		vendor: "",
	});
	const [loadingImg, setLoadingImg] = useState(false);
	const [vendorsOptions, setVendorsOptions] = useState([]);
	const navigate = useNavigate();
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const reviewService = new ReviewsService();
	const vendorsService = new VendorsService();

	useEffect(() => {
		vendorsService.getList().then((res) => {
			if (res?.status) {
				let response = res?.data?.data?.data?.map((info) => {
					return {
						...info,
						label: info[`name_${lang}`],
						value: info?.id,
					};
				});
				setVendorsOptions(response);
			}
		});
	}, []);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name_en: item?.review_en,
				name_ar: item?.review_ar,
				image: item?.review_image,
				no_of_stars: item?.no_of_stars,
				vendor: {
					label: item[`name_${lang}`],
					value: item?.id,
				},
			});
		}
	}, [location]);

	const fileHandler = (e) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!filesData?.length) {
			return;
		}
		setLoadingImg(true);
		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData((prev) => ({ ...prev, image: res.data.url }));
			}
			setLoadingImg(false);
		});
	};

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.vendor) {
			if (!formData?.vendor) toast.error("Select Vendor");
			return;
		}

		let data = {
			review_en: formData?.name_en,
			review_ar: formData?.name_ar,
			no_of_stars: formData?.no_of_stars,
			review_image: formData?.image,
			vender_id: formData?.vendor?.value,
		};

		setLoading(true);
		if (isAdd) {
			reviewService.create(data)?.then((res) => {
				if (res?.status === 201) {
					toast.success("Review Added Successfully");
					setAddModal();
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			});
		} else {
			reviewService.update(formData?.id, data)?.then((res) => {
				if (res?.status === 200) {
					toast.success("Review Updated Successfully");
					setAddModal();
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			});
		}
	};

	const inputHandlerChange = (e) => {
		setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<Modal.Body>
				<AvForm className="form-horizontal" onValidSubmit={submit}>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0 text-black fw-bold"
									style={{
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.review}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Name En */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.name} ({Translate[lang]?.english})
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_en}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Name Ar */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.name} ({Translate[lang]?.arabic})
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name_ar"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_ar}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* No. of Stars */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.no_of_stars}
							</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.no_of_stars}
								bsSize="lg"
								name="no_of_stars"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								max={5}
								value={formData.no_of_stars}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Vendor */}
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.vendor}</label>
							<Select
								placeholder={Translate[lang]?.select}
								bsSize="lg"
								options={vendorsOptions}
								name="vendor"
								value={formData.vendor}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, vendor: e }))
								}
							/>
						</Col>
						{/* Image */}
						<Col md={12} className="mb-4">
							<label className="text-label mb-0">{Translate[lang].image}</label>
							<div className="upload">
								<input
									type="file"
									name="image"
									id="image"
									onChange={(e) => fileHandler(e)}
								/>
								<p>{Translate[lang].upload_image}</p>
								{loadingImg ? (
									<LoaderImg />
								) : !formData?.image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{!!formData?.image && (
								<img
									src={formData?.image}
									alt="category"
									width={80}
									className="mt-3"
								/>
							)}
						</Col>
					</Row>
					<Row>
						<Col md={12} className="mt-4">
							<Button
								variant="primary"
								type="submit"
								className="w-100"
								disabled={loading}>
								{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
								{Translate[lang]?.reviews}
							</Button>
						</Col>
					</Row>
				</AvForm>
			</Modal.Body>
		</Modal>
	);
};

export default AddReviewsModal;
